// extracted by mini-css-extract-plugin
export default {"vendorLogo":"vendorLogo__M2VkY","zolaLogo":"zolaLogo__ZDBmO"};